<template>
  <b-modal
    id="modal-settings"
    v-bind:title="strings['live.sky.view.settings']"
    class="text-light"
    @ok="onOk"
    @cancel="onCancel"
    v-bind:cancel-title="strings['cancel']"
    v-bind:ok-title="strings['Update']"
  >
    <!-- size="lg" -->
    <b-form variant="dark" class="text-light modalDialog">
      <b-form-group
        id="input-group-1"
        v-bind:label="strings['magnitude.limit'] + ':'"
        label-for="sb-mag-limit"
        v-bind:description="strings['magnitude.limit.description']"
      >
        <b-form-spinbutton
          id="sb-mag-limit"
          v-model="magLimit"
          min="2"
          max="5"
          step="0.5"
          size="sm"
          class="bg-dark text-light border-light"
        ></b-form-spinbutton>
      </b-form-group>
      <b-form-group
        v-bind:label="strings['elevation.limit'] + ':'"
        label-for="input-elev-limit"
        v-bind:description="strings['elevation.limit.description']"
      >
        <b-form-input
          id="input-elev-limit"
          v-model="elevLimit"
          size="sm"
          class="bg-dark text-light border-light"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-bind:label="strings['currently.visible.satellites.sorted.by'] + ':'">
        <b-form-radio-group v-model="satSort" name="sort-radios">
          <b-form-radio value="E">{{strings['altitude']}}</b-form-radio>
          <b-form-radio value="M">{{strings['Magnitude']}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group v-bind:label="strings['sky.chart.features'] + ':'" v-bind:description="strings['chart.features.description']">
        <b-container fluid>
          <b-row><b-col class="col-6">
        <b-form-checkbox class="mt-2" v-model="showSatLabels">{{strings["satellite.labels"]}}</b-form-checkbox>
        <b-form-checkbox class="mt-2" v-model="showConstellationLabels">{{strings["constellation.names"]}}</b-form-checkbox>
        <b-form-checkbox class="mt-2" v-model="showConstellationBoundaries">{{strings["constellation.boundaries"]}}</b-form-checkbox>
        <b-form-checkbox class="mt-2" v-model="showAsterisms">{{strings["constellation.lines"]}}</b-form-checkbox>
        </b-col>
        <b-col class="col-6">
        <b-form-checkbox class="mt-2" v-model="showStarLabels">{{strings["star.names"]}}</b-form-checkbox>
        <b-form-checkbox class="mt-2" v-model="showEcliptic">{{strings["ecliptic.plane"]}}</b-form-checkbox>
        <b-form-checkbox class="mt-2" v-model="showEquator">{{strings["celestial.equator"]}}</b-form-checkbox>
        <b-form-checkbox class="mt-2" v-model="showSkyShading">{{strings["sky.shading"]}}</b-form-checkbox>
        </b-col>
          </b-row>
        </b-container>
      </b-form-group>
    </b-form>
  </b-modal>
</template>
<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import { mapState } from "vuex";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  name: "LiveSkyPageSettings",

  computed: mapState(["utc", "location", "culture", "settings", "strings"]),

  data() {
    return {
      magLimit: 5,
      elevLimit: 20,
      showSatLabels: false,
      showConstellationLabels: false,
      showConstellationBoundaries: false,
      showAsterisms: false,
      showStarLabels: false,
      showEcliptic: false,
      showEquator: false,
      showSkyShading: false,
      satSort: ''
    };
  },
  mounted() {
    this.reset();
  },
  methods: {
    onOk() {
      //evt.preventDefault();
      this.settings.magLimit = this.magLimit;
      this.settings.elevLimit = this.elevLimit;
      this.settings.showConstellationLabels = this.showConstellationLabels;
      this.settings.showConstellationBoundaries = this.showConstellationBoundaries;
      this.settings.showAsterisms = this.showAsterisms;
      this.settings.showStarLabels = this.showStarLabels;
      this.settings.showEcliptic = this.showEcliptic;
      this.settings.showEquator = this.showEquator;
      this.settings.showSkyShading = this.showSkyShading;
      this.settings.showSatLabels = this.showSatLabels;
      this.settings.satSort = this.satSort;

      this.$store.commit("setSettings", this.settings);
      this.$bvModal.hide("modal-settings");
    },
    onCancel() {
      this.reset();
      //this.$bvModal.hide("modal-settings");
    },
    reset() {
      this.magLimit = this.settings.magLimit;
      this.elevLimit = this.settings.elevLimit;
      this.showSatLabels = this.settings.showSatLabels;
      this.showConstellationLabels = this.settings.showConstellationLabels;
      this.showConstellationBoundaries = this.settings.showConstellationBoundaries;
      this.showAsterisms = this.settings.showAsterisms;
      this.showStarLabels = this.settings.showStarLabels;
      this.showEcliptic = this.settings.showEcliptic;
      this.showEquator = this.settings.showEquator;
      this.showSkyShading = this.settings.showSkyShading;
      this.satSort = this.settings.satSort;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>
